import { MedProductType } from "src/utils/constants";
import { registerHandler, Sha256Email } from "../handler";
import uuid from "uuid";
import { getPinterestPixelId } from "src/utils/userSegment/pixelUtils";

declare const pintrk: any;

interface PinterestParams {
  planId: string;
  duration: number;
}

const NOOM_WEIGHT_CONVERSION_EVENT = "checkout";
const NOOM_MED_PURCHASE_INTENT_EVENT = "checkout";

function convertToPinConvParam(params: Record<string, any>) {
  const convParam: string[] = [];
  Object.keys(params).forEach((key) => {
    const param = params[key];
    if (param != null && param) {
      convParam.push(`${key}:${param.toString()}`);
    }
  });
  return convParam.join(",");
}

function trackPinterestConversion(order, plan, event) {
  const pinParams: PinterestParams = {
    planId: plan.braintree_id,
    duration: plan.billing_cycle_duration,
  };
  const convParam = convertToPinConvParam(pinParams);
  pintrk("track", event, {
    value: order.eltv_13_months,
    order_quantity: 1,
    currency: "USD",
    // adding the subscription id as event_id too for deduplication purposes
    event_id: order.subscriptionId,
    order_id: order.subscriptionId,
    conv_param1: convParam,
  });
}

function trackPinterestPurchaseIntent(value) {
  pintrk("track", NOOM_MED_PURCHASE_INTENT_EVENT, {
    value,
    order_quantity: 1,
    currency: "USD",
    // generating a uuid here as event_id for deduplication purposes
    event_id: uuid.v4(),
  });
}

function trackPinterestLead(email: Sha256Email) {
  // Advanced tracking for Pinterest (enables Enhanced Match).
  const tagId = getPinterestPixelId();
  if (email) {
    pintrk("load", tagId, {
      em: email,
    });
  }
  pintrk("track", "lead");
}

// https://developers.pinterest.com/docs/ad-tools/conversion-tag/
export default function registerHandlers() {
  registerHandler("lead", ({ emailHashes }) => {
    trackPinterestLead(emailHashes.sha256);
  });

  registerHandler("purchase", ({ order, plan }) => {
    trackPinterestConversion(order, plan, NOOM_WEIGHT_CONVERSION_EVENT);
  });

  registerHandler("purchaseIntent", ({ estimatedValue, medProductType }) => {
    if (medProductType !== MedProductType.HRT) {
      trackPinterestPurchaseIntent(estimatedValue);
    }
  });
}
